
import RouteSquare from "../../../assets/outline/RouteSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RouteSquareIcon({ className, dataTestid = "RouteSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RouteSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
